export default __webpack_public_path__ + "static/media/soesvinget-property-16.a86ed2f3.jpg";